// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZLNAcZvaJ7UYd2 {
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  background: transparent;
}
.ZLNAcZvaJ7UYd2 svg {
  transform: scale(1);
  transition: transform 85ms ease-in-out;
}
.ZLNAcZvaJ7UYd2:hover,
.ZLNAcZvaJ7UYd2:focus,
.ZLNAcZvaJ7UYd2:active {
  background: transparent;
}
.ZLNAcZvaJ7UYd2:hover svg,
.ZLNAcZvaJ7UYd2:focus svg,
.ZLNAcZvaJ7UYd2:active svg {
  transform: scale(1.2);
}
`, ""]);
// Exports
export var button = `ZLNAcZvaJ7UYd2`;
export default ___CSS_LOADER_EXPORT___;
